import React, { useState, useEffect } from "react";
import "../Services/Transpo.css";
import Navbar from "../../components/Navbar/Navbar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import CatCards from "../../components/Cards/CatCards";
import Search from "@mui/icons-material/Search";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import CatCardsNew from "../../components/Cards/CatCardsNew";
import { Slider, Box, Typography, TextField } from "@mui/material";

const Transportation = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const [commissions, setCommissions] = useState([]);
  const [filter, setFilter] = useState({
    term: "",
    status: "",
    date: "",
    minPay: "",
    maxPay: "",
    location: "",
  });

  const handleSliderChange = (event, newValue) => {
    setFilter((prev) => ({
      ...prev,
      minPay: newValue[0],
      maxPay: newValue[1],
    }));
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  useEffect(() => {
    const fetchAllCommission = async () => {
      try {
        const res = await axios.get(
          `https://errand-catcher-backend-git-f68eb5a02ca4.herokuapp.com/type/Transportation`
        );
        setCommissions(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchAllCommission();
  }, []);

  // Search commmissions using JS filter method //
  const filteredCommissions = commissions.filter((commission) => {
    const titleMatches = commission.commissionTitle
      .toLowerCase()
      .includes(searchQuery.toLowerCase());
    const locationMatches = commission.commissionLocation
      .toLowerCase()
      .includes(filter.location.toLowerCase());
    //if price range has been entered
    let priceMatches = true;
    if (filter.minPay !== "" && filter.maxPay !== "") {
      priceMatches =
        commission.commissionPay >= filter.minPay &&
        commission.commissionPay <= filter.maxPay;
    }

    return titleMatches && locationMatches && priceMatches;
  });

  const handleChange = (e) => {
    if (e.target.name === "location") {
      setFilter((prev) => ({ ...prev, location: e.target.value }));
    } else {
      setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    }
  };

  return (
    <>
      <div class="row bg-primary">
        <div class="col d-flex justify-content-center">
          <h1 style={{ position: "relative", color: "white" }}>
            <DirectionsCarIcon
              sx={{
                color: "skyblue",
                // position: "absolute",
                marginRight: "7px",
                left: "15px",
                fontSize: 28,
              }}
            />
            Transportation
          </h1>
        </div>
      </div>

      <div class="row ">
        <div className="search-barborder">
          {/* <div class="col">
            <h1 className="headingTranspo">Transportation</h1>
          </div> */}

          <div className="box">
            <div class="col d-flex justify-content-start">
              <Search
                sx={{
                  position: "absolute",
                  color: "grey",
                  margin: "11px",
                }}
              />
              <input
                style={{ paddingLeft: "32px" }}
                className="inputSearch"
                type="text"
                placeholder="Search..."
                value={searchQuery}
                onChange={handleSearchChange}
              />
            </div>
            <div class="col">
              <LocationOnIcon
                sx={{
                  position: "absolute",
                  color: "grey",
                  margin: "8px",
                }}
              />

              <select
                style={{ paddingLeft: "32px" }}
                className="selected"
                name="location"
                id="location"
                value={filter.location}
                onChange={handleChange}
              >
                <option value="">Choose Location....</option>
                <option value="Cebu">Cebu</option>
                <option value="Cordova">Cordova</option>
                <option value="Mandaue">Mandaue</option>
                <option value="Lapu-Lapu">Lapu-Lapu</option>
                <option value="Talisay">Talisay</option>
              </select>
            </div>

            <div class="col">
              <div className="Paylabel">
                <div style={{ textAlign: "center" }} >
                  <Typography color="#f5f5f5" variant="h6"
                    sx={{
                      fontSize: 18,
                      fontWeight: 460,
                      letterSpacing: "1.2px",
                      // fontStyle: "italic"
                    }}
                  >
                    Payment Range:
                  </Typography>

                  <Slider className="sliderpay"
                    value={[
                      Number(filter.minPay),
                      Number(filter.maxPay)
                    ]}
                    onChange={handleSliderChange}
                    // valueLabelDisplay="on"
                    min={500}
                    max={filter.maxPay}
                    // step={100}
                    sx={{
                      marginTop: 2,
                      color: "white",
                    }}
                  />
                </div>
                <label htmlFor="">
                  {/* <Typography variant="h7">Payment Range:</Typography> */}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <input
                      style={{
                        padding: "4px 2px",
                      }}
                      className="inputNum"
                      type="number"
                      placeholder="Minimum"
                      name="minPay"
                      onChange={handleChange}
                      value={filter.minPay}
                    />
                    <SyncAltIcon sx={{ color: "#fff", fontSize: 24 }} />
                    <input
                      style={{
                        padding: "4px 2px",
                      }}
                      className="inputNum"
                      type="number"
                      placeholder="Maximum"
                      name="maxPay"
                      onChange={handleChange}
                      value={filter.maxPay}
                    />
                  </Box>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <CatCards commissions={filteredCommissions} /> */}
      {/* <CatCardsNew commissions={filteredCommissions} /> */}

      {filteredCommissions && filteredCommissions.length > 0 ? (
        <>
          <CatCardsNew commissions={filteredCommissions} />
        </>
      ) : (
        <>
          <div
            style={{
              height: "50vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <h1 style={{ fontWeight: "600" }}>
              Opps!
            </h1>
            <h2 style={{ textAlign: "center" }} >
              No errand found
              <span style={{
                fontStyle: "italic",
                fontWeight: "600",
                // color: "#378ce7",
              }}> "Transportation"</span> as of now..
            </h2>
          </div>
        </>
      )}
    </>
  );
};

export default Transportation;

{
  /* <>

<div className="search-barborder">
<h1 className="headingTranspo">Transportation</h1>
  
  <div className="box">
  <input className="inputSearch"
    type="text"
    placeholder="Search..."
    value={searchQuery}
    onChange={handleSearchChange}
  />

<select className="selected"
  name="location"
  id="location"
  value={filter.location}
  onChange={handleChange}
>
  <option value="">Choose Location....</option>
  <option value="Cebu">Cebu</option>
  <option value="Cordova">Cordova</option>
  <option value="Mandaue">Mandaue</option>
  <option value="Lapu-Lapu">Lapu-Lapu</option>
  <option value="Talisay">Talisay</option>
</select>

<div className="Paylabel">
<label htmlFor="">Payment range:
  <input className="inputNum"
    type="number"
    placeholder="Starting range..."
    name="minPay"
    onChange={handleChange}
    value={filter.minPay}
  />
  <input className="inputNum"
    type="number"
    placeholder="Maximum range..."
    name="maxPay"
    onChange={handleChange}
    value={filter.maxPay}
  />
</label>
</div>
  </div>
</div>

<CatCards commissions={filteredCommissions} />
</> */
}
